const EMAIL_REQUEST = 'EMAIL_REQUEST';
const EMAIL_SUCCESS = 'EMAIL_SUCCESS';
const EMAIL_FAILURE = 'EMAIL_FAILURE';

const setEmailData = (type, payload, payloadAction = false) => ({
    type,
    payload,
    payloadAction,
});

const initialState = {
    emailloading: false,
    emailapiValues: null,
    emailactiontype: false,
    emailerror: null,
};

const apiEmailReducer = (state = initialState, action) => {
    switch (action.type) {
        case EMAIL_REQUEST:
            return {
                ...state,
                emailloading: true,
                emailerror: null,
                emailactiontype: false,
            };
        case EMAIL_SUCCESS:
            return {
                ...state,
                emailloading: false,
                emailactiontype: action.payloadAction,
                emailapiValues: action.payload,
            };
        case EMAIL_FAILURE:
            return {
                ...state,
                emailloading: false,
                emailactiontype: false,
                emailerror: action.payload,
            };
        default:
            return state;
    }
};

export { apiEmailReducer, setEmailData };
